import { combineReducers } from "redux"
import { activation } from './userPermissionActivationReducer'

const activationPermissionReducers = combineReducers({
    activation,
})

export default activationPermissionReducers